// packages/content/src/assets/index.ts
import { assetModules } from '../assets.gen';
import type { AssetBank, AssetEntry } from '../schema/assets';
import type { CatalogId } from '../schema/ids';

export function buildAssetMap(modules: Readonly<Record<string, AssetBank>>): ReadonlyMap<CatalogId, AssetEntry> {
  const map = new Map<CatalogId, AssetEntry>();
  for (const bank of Object.values(modules)) for (const [id, e] of Object.entries(bank)) {
    if (map.has(id)) throw new Error(`duplicate asset id ${id}`);
    map.set(id, e);
  }
  return map;
}
export const assetMap: ReadonlyMap<CatalogId, AssetEntry> = buildAssetMap(assetModules as Readonly<Record<string, AssetBank>>);
export function getAssetEntry(id: CatalogId): AssetEntry | undefined { return assetMap.get(id); }
